import { api } from '../creat-api'
// 节目集列表
export function programSets (params) {
  return api({
    url: '/programSets',
    params
  })
}
// 添加节目集
export function addProgramSets (params) {
  return api({
    method: 'POST',
    url: '/programSets',
    data: params
  })
}
// 编辑节目集
export function editProgramSets (params) {
  return api({
    method: 'PUT',
    url: '/programSets',
    data: params
  })
}
// 节目集审核未通过原因查询
export function checkReason (params) {
  return api({
    url: '/audit/checkReason',
    params
  })
}
// 节目集管理列表
export function programs (params) {
  return api({
    url: '/programs',
    params
  })
}
// cp节目集管理列表
export function fetchCpPrograms (params) {
  return api({
    url: '/cpPrograms',
    params
  })
}
// vod节目集 播放量、浏览量
export function getProgramGroupCount (params) {
  return api({
    method: 'POST',
    url: '/programSets/getProgramGroupCount',
    data: params
  })
}
// 节目集管理-批量移除、添加
export function bindOrUnbind (params) {
  return api.put('/programs/bindOrUnbind', params)
}
// 节目集批量送审
export function batchAuditProgramSets (params) {
  return api.post('/audit/programSets', params)
}
// 单个节目集-送审
export function sendPrograms (params) {
  return api.post('/audit/singleProgramSet', params)
}
// 节目集-批量删除
export function programSetsDel (params) {
  return api({
    method: 'DELETE',
    url: '/programSets',
    data: params
  })
}
// 节目集-详细数据图表
export function getProgramGroupDetailDate (params) {
  return api({
    method: 'POST',
    url: '/programSets/getProgramGroupDetailDate',
    data: params
  })
}
// 节目集获取发布状态
export function pushFlag (params) {
  return api({
    url: `/programSets/pushFlag/${params.id}?companyId=${params.companyId}`
  })
}

export function publishProgram (params) {
  return api.post('/programSets/push', params)
}
